import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Pencil, Trash2, Plus, X } from "lucide-react";

const empty = { question: "", answer: "", category: "General" };

export default function AdminFAQs() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);

  const load = () => api.get("/faqs").then(r => setItems(r.data));
  useEffect(() => { load(); }, []);

  const startEdit = (f) => { setEditing(f); setForm({ ...f }); };
  const startNew = () => { setEditing("new"); setForm(empty); };
  const close = () => { setEditing(null); setForm(empty); };

  const save = async (e) => {
    e.preventDefault();
    try {
      if (editing === "new") await api.post("/faqs", form);
      else await api.put(`/faqs/${editing.id}`, form);
      toast.success("Saved"); close(); load();
    } catch { toast.error("Save failed"); }
  };
  const remove = async (id) => { if (confirm("Delete?")) { await api.delete(`/faqs/${id}`); load(); } };

  return (
    <div data-testid="admin-faqs">
      <div className="flex items-center justify-between mb-8">
        <h1 className="font-display text-3xl text-[color:var(--color-primary)]">FAQs</h1>
        <button onClick={startNew} className="btn-accent" data-testid="add-faq-btn"><Plus className="w-4 h-4"/> New FAQ</button>
      </div>

      <div className="bg-white border border-[color:var(--color-border)] rounded overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-xs uppercase tracking-widest text-gray-500">
            <tr><th className="text-left p-3">Question</th><th className="text-left p-3">Category</th><th className="text-right p-3">Actions</th></tr>
          </thead>
          <tbody>
            {items.map((f) => (
              <tr key={f.id} className="border-t border-[color:var(--color-border)]">
                <td className="p-3 font-medium">{f.question}</td>
                <td className="p-3">{f.category}</td>
                <td className="p-3 text-right">
                  <button onClick={() => startEdit(f)} className="p-1.5 hover:bg-gray-100 rounded" data-testid={`edit-faq-${f.id}`}><Pencil className="w-4 h-4"/></button>
                  <button onClick={() => remove(f.id)} className="p-1.5 text-red-500 hover:bg-red-50 rounded ml-2" data-testid={`delete-faq-${f.id}`}><Trash2 className="w-4 h-4"/></button>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan="3" className="p-8 text-center text-gray-500">No FAQs yet.</td></tr>}
          </tbody>
        </table>
      </div>

      {editing && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" data-testid="faq-form-modal">
          <div className="bg-white rounded-lg p-8 w-full max-w-lg">
            <div className="flex items-center justify-between mb-4">
              <h2 className="font-display text-2xl">{editing === "new" ? "New FAQ" : "Edit FAQ"}</h2>
              <button onClick={close}><X className="w-5 h-5"/></button>
            </div>
            <form onSubmit={save} className="space-y-3">
              <input required placeholder="Question" value={form.question} onChange={(e) => setForm({ ...form, question: e.target.value })} className="w-full border border-[color:var(--color-border)] rounded px-3 py-2" data-testid="faq-question"/>
              <textarea required rows="4" placeholder="Answer" value={form.answer} onChange={(e) => setForm({ ...form, answer: e.target.value })} className="w-full border border-[color:var(--color-border)] rounded px-3 py-2" data-testid="faq-answer"/>
              <input placeholder="Category" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className="w-full border border-[color:var(--color-border)] rounded px-3 py-2" data-testid="faq-cat"/>
              <div className="flex gap-3 pt-2">
                <button type="button" onClick={close} className="btn-ghost flex-1 justify-center">Cancel</button>
                <button type="submit" className="btn-primary flex-1 justify-center" data-testid="faq-save">Save</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
